// extracted by mini-css-extract-plugin
export default {"BackupsList":"BackupsList_BackupsList__-LTxA","actions":"BackupsList_actions__xeNa7"};